/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { InvoiceTransaction } from './InvoiceTransaction';
// @ts-ignore
import {
// @ts-ignore
    InvoiceTransactionFromJSON,
// @ts-ignore
    InvoiceTransactionFromJSONTyped,
// @ts-ignore
    InvoiceTransactionToJSON,
} from './InvoiceTransaction';

/**
 * 
 * @export
 * @interface InvoiceTransactionListResponse
 */
export interface InvoiceTransactionListResponse {
    /**
     * 
     * @type {number}
     * @memberof InvoiceTransactionListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceTransactionListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<InvoiceTransaction>}
     * @memberof InvoiceTransactionListResponse
     */
    items: Array<InvoiceTransaction>;
}

/**
 * Check if a given object implements the InvoiceTransactionListResponse interface.
 */
// @ts-ignore
export function instanceOfInvoiceTransactionListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function InvoiceTransactionListResponseFromJSON(json: any): InvoiceTransactionListResponse {
    return InvoiceTransactionListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceTransactionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceTransactionListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(InvoiceTransactionFromJSON)),
    };
}

// @ts-ignore
export function InvoiceTransactionListResponseToJSON(value?: InvoiceTransactionListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(InvoiceTransactionToJSON)),
    };
}

